import requestInstance from '../../utils/instance-utils';

export const getTypeOfContentExistsForClient = (
    clientId: Number,
    isWhitelisted: boolean
) =>
    requestInstance.get(
        `/content/type-of-contents-exists?clientId=${clientId}`,
        {
            headers: { 'X-Is-Whitelisted': String(isWhitelisted) },
        }
    );
